import template from './ko-render-field-email.html';

class EmailInputComponentVM
{
	constructor(params)
	{
		this.params = params;

		this.readonly = ko.observable();
		this.name = ko.observable(params.name);
		this.label = ko.observable(params.label);
		this.hide_labels = ko.observable(params.hide_labels);
		this.$input = params.$input;
		this.readonly = ko.observable(params.readonly);
	}
}


export default {
	name: 'ko-render-field-email',
	viewModel: EmailInputComponentVM,
	module_type: 'ko',
	template: template
}
